import React, { useEffect } from "react";

import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { SelectBox } from "@/components/holders/SelectBox";
import { ArrowLongRightIcon } from '@heroicons/react/24/outline'
import { TimeBox } from "@/components/holders/TimeBox";
import { Calender } from "@/components/holders/Calender";

export function TimeRegistrationPanel({...props}) {
   const [open, setOpen] = useState(props.showTimeRegistration);
   const [registrationItem, setRegistrationItem] = useState(props.selected);
   
   const [departments, setDepartments] = useState([]);
   let customers = props.customers;
   let {users, sectors, authUser, worktype} = props;
  useEffect(() => {
    if(departments.length == 0 && registrationItem.sector["key"] != "") {
        for(let i in sectors) {
            if(sectors[i]["key"] === registrationItem.sector["key"]) {
                setDepartments(sectors[i]["children"]);
                break;
            }
        }
    }
    return () => {

    };
  }, [registrationItem, departments]);
    
    const saveTimeRegistration=() => {
        if(props.onSaveEvent) {
            props.onSaveEvent(registrationItem);
        }
        //setOpen(false);
    }
      
   const setValueCombobox= (name, selected) => {
       registrationItem[name] = selected;
       setRegistrationItem(registrationItem);;
   }
   
   const changeSectorEventHandler = (name, val) => {
       let departmentSelector = [];
       
       if(val) {
           //departmentSelector.push( createDepartmentSelector(val.id, val.children, "") );
           departmentSelector = val.children;
       }
       setDepartments(departmentSelector);
       registrationItem.sector = val;
       registrationItem.department = null;
       //setValueCombobox(name, val);
   }
   const createDepartmentSelector=(key, departments = null, selected= "", disabled= false) => {
       return (<SelectBox key={key} name="department" className="" label="Afdeling" data={departments} selected={selected} boxfield="name" placeHolder="Selecteer een afdeling" disabled={disabled} changeEvent={(name, val) => setValueCombobox(name,val)} />)
   }

       
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-5xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
            
            <div className="mt-10 grid grid-cols-2 gap-x-5 gap-y-8 sm:grid-cols-2">
                <div className="">
                <div className="sm:col-span-3">
                    <SelectBox key="customer" className="" label="Voor klant" name="customer" data={customers} boxfield="name" selected={registrationItem.customer} placeHolder="Selecteer een klant" changeEvent={(name, val) => setValueCombobox(name,val)}/>
                </div>
                
                <div className="sm:col-span-3">
                    <SelectBox key="user" className="" label="Medewerker" name="user" data={users} selected={(!(registrationItem.user && registrationItem.user["id"])) ? authUser : registrationItem.user} boxfield="fullName" placeHolder="Registratie voor gebruiker" changeEvent={(name, val) => setValueCombobox(name,val)}/>
                </div>
                
                <div className="sm:col-span-3">
                    <SelectBox key="sector" className="" label="Organisatie sector" name="organisation_sector" data={sectors} selected={registrationItem.sector} changeEvent={(name, selectedSector) => changeSectorEventHandler(name, selectedSector)} boxfield="name"  placeHolder="Selecteer een organisatie sector"/>
                </div>
                <div className="sm:col-span-3">
                    <SelectBox key={registrationItem.sector.key} className="" label="Afdeling"  name="department"  placeHolder="Selecteer eerst de sector" disabled={(!registrationItem.sector["key"])} data={departments} selected={registrationItem.department} boxfield="name" changeEvent={(name, val) => setValueCombobox(name,val)}/>
                </div>
                <div className="sm:col-span-3">
                    <SelectBox key={"worktype"} className="" label="Type werk"  name="worktype"  placeHolder="Type werk" boxfield="name" data={worktype} selected={registrationItem.worktype}  changeEvent={(name, val) => setValueCombobox(name,val)}/>
                </div>
                
                </div>

                <div className="">
                
                <div>
                    <Calender changeEvent={(name, val) => setValueCombobox(name,val)} name="worklog_date" defaultValue={registrationItem.worklog_date}/>
                
                </div>
                
                <TimeBox className="" name="hour-min" changeEvent={(name, val) => setValueCombobox(name,val)} defaultValue={registrationItem}/>
                
                </div>
                
            </div>
                
                
                    <div>
      <label htmlFor="comment" className="block text-sm font-medium leading-6 text-gray-900">
        Omschrijving
      </label>
      <div className="mt-2">
        <textarea
          id="comment"
          name="comment"
          rows={4}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={registrationItem.description}
          onBlur={(event) => {registrationItem.description = event.currentTarget.value; setRegistrationItem(registrationItem);}}
        />
      </div>
    </div>
                
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                onClick={() => saveTimeRegistration()}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
              >
                Opslaan
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => setOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
